import React from 'react';
import { DropZone } from './tabs/DropZone';
import { DropZone as DropZoneType, DragState } from '../../types';

interface DragOverlayProps {
  dragState?: DragState;
  isDragging: boolean;
  onDrop?: (zone: DropZoneType, draggedTabId: string, draggedFromPaneId: string) => void;
}

/**
 * ドラッグオーバーレイコンポーネント
 * ドラッグ中のみ表示される独立したオーバーレイ
 */
export const DragOverlay: React.FC<DragOverlayProps> = ({ dragState, isDragging, onDrop }) => {

  // ドラッグ中でない場合は何も表示しない
  if (!isDragging || !dragState) {
    return null;
  }


  return (
    <div 
      className="drag-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none', // オーバーレイ自体はクリック不可
        zIndex: 1000
      }}
    >
      {dragState.dropZones.map((dropZone) => {
        return (
          <DropZone
            key={dropZone.id}
            zone={dropZone}
            isActive={true}
            onDrop={(zoneId: string) => {
            
            // 実際のドロップゾーンオブジェクトを見つけて外部ハンドラーに渡す
            const zone = dragState.dropZones.find(z => z.id === zoneId);
            if (zone && onDrop) {
              onDrop(zone, dragState.draggedTabId, dragState.draggedFromPaneId);
            }
          }}
            debug={true}
          />
        );
      })}
    </div>
  );
};

export default DragOverlay;
